// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"1d04725a","574":"d1981094"}[chunkId] + ".chunk.css";
};